import * as React from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import { FeedbackForm } from "./FeedbackForm";
import { Button } from "../ui/button";

export function FeedbackSidebar({ isOpen, onClose, onSubmit }) {
  const sidebarRef = React.useRef(null);

  React.useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  return (
<div
  ref={sidebarRef}
  className={
    "z-[100] fixed inset-y-0 right-0 bg-white border-l shadow-lg w-full md:w-[400px] transform transition-transform duration-300 ease-in-out " +
    (isOpen ? "translate-x-0" : "translate-x-full")
  }
>
  <div className="flex h-full flex-col">
    {/* 헤더 영역 */}
    <div className="bg-white border-b p-4 flex justify-between items-center">
      <h2 className="text-xl font-semibold">Feedback</h2>
      <Button variant="ghost" size="icon" onClick={onClose}>
        <X className="h-5 w-5" />
      </Button>
    </div>

    {/* 컨텐츠 영역 */}
    <div className="flex-1 overflow-auto p-4 md:p-6">
      <FeedbackForm onSubmit={onSubmit} />
    </div>
  </div>
</div>
  );
}
